import React, { useEffect, useState } from 'react';
import classes from './CanteenPay.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import useSound from 'use-sound';
import successSound from './../../../utilities/success.mp3';
import { canteenMenu } from '../../../API/API';
import { closePaymenu, paymenIsSuccessfull } from './../../../Redux/action/interactions';
import { canteenPay, walletHistory } from './../../../API/API';
import debounce from 'lodash/debounce';
import { useNavigate } from "react-router-dom";

const PayMenuOtherSnacks = () => {
    const data = JSON.parse(localStorage.getItem('data'));
    const userID = localStorage.getItem('userID');
    const [isVisible, setIsVisible] = useState(true);
    const [amount, setAmount] = useState(0);
    const [message, setMessage] = useState('');
    const [order, setOrder] = useState([]);

    const paySuccess = useSelector(state => state.interactions.paymentSuccess);
    const dispatch = useDispatch();
    const [play] = useSound(successSound);
    const [isButtonDisabled, setButtonDisabled] = useState(false);
    const navigate = useNavigate();

    const disableButton = () => setButtonDisabled(true);
    const enableButton = () => setButtonDisabled(false);

    const [transHistory, setHistory] = useState([]);
    useEffect(() => {
        if (userID && data) {
            walletHistory(userID, data.empid, data.token)
                .then(response => setHistory(response.data))
                .catch(() => {
                    setHistory([]);
                    toast("Unable to Fetch Wallet History", {
                        icon: '❗',
                        duration: 4500
                    });
                });
        }
    }, [userID, order]);

    const handlePay = (event) => {
        event.preventDefault();
        disableButton();
        debounce(payAmount, 100)();
    };

    const payAmount = () => {
        if (data && userID) {
            const amt = parseInt(amount);
            if (amt === 0) {
                toast.error("Amount is 0");
                return;
            }
            if (amt.toString().trim().length === 0) {
                toast.error("Please Enter Amount");
                return;
            }
            if (amt < 0) {
                toast.error("Amount Cannot Be Negative");
                return;
            }

            canteenPay(userID, data.empid, data.token, amt, message.toString())
                .then((response) => {
                    if (response.data.message === "INVALIDDRAMOUNT") {
                        dispatch(closePaymenu(false));
                        toast.error("Please Enter a Valid Amount");
                    } else if (response.data.message === "success" && response.data.response === "OK") {
                        dispatch(closePaymenu(false));
                        dispatch(paymenIsSuccessfull());
                        play();
                        toast.success(`Paid Successfully`, {
                            duration: 4000
                        });
                        setIsVisible(false);
                    }
                    if (order) navigate("/dashboard/canteenpay");
                })
                .catch(() => {
                    toast.error("Canteen Payment Not Working Try After Sometime", {
                        duration: 4000
                    });
                    dispatch(closePaymenu(false));
                });
        }
    };

     const [menuItems, setMenuItems] = useState([]);
    const handleAddItem = (itemName) => {
        const existingItem = menuItems.find((item) => item.name === itemName);
        if (existingItem) {
            setMenuItems(menuItems.map((item) =>
                item.name === itemName ? { ...item, quantity: item.quantity + 1, amt: item.amt + parseFloat(itemName.split('-')[1]) } : item
            ));
        } else {
            setMenuItems([...menuItems, { name: itemName, quantity: 1, amt: parseFloat(itemName.split('-')[1]) }]);
        }
    };

    const handleRemoveItem = (itemName) => {
        setMenuItems((prevMenuItems) => {
            const existingItemIndex = prevMenuItems.findIndex((item) => item.name === itemName);

            if (existingItemIndex !== -1) {
                const updatedItems = [...prevMenuItems];

                if (updatedItems[existingItemIndex].quantity > 1) {
                    updatedItems[existingItemIndex].quantity -= 1;
                    updatedItems[existingItemIndex].amt -= parseFloat(itemName.split('-')[1]);
                    return updatedItems;
                } else {
                    updatedItems.splice(existingItemIndex, 1);
                    return updatedItems;
                }
            } else {
                return prevMenuItems;
            }
        });
    };

    const [menu, setMenu] = useState({
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
    });

    // useEffect(() => {
    //     if (data && userID) {
    //         canteenMenu(userID, data.empid, data.token, data.company)
    //             .then(response => {
    //                 const Monday = response.data.filter(item => item.fday === "Monday");
    //                 const Tuesday = response.data.filter(item => item.fday === "Tuesday");
    //                 const Wednesday = response.data.filter(item => item.fday === "Wednesday");
    //                 const Thursday = response.data.filter(item => item.fday === "Thursday");
    //                 const Friday = response.data.filter(item => item.fday === "Friday");
    //                 const Saturday = response.data.filter(item => item.fday === "Saturday");

    //                 setMenu({
    //                     Monday: Monday[0],
    //                     Tuesday: Tuesday[0],
    //                     Wednesday: Wednesday[0],
    //                     Thursday: Thursday[0],
    //                     Friday: Friday[0],
    //                     Saturday: Saturday.length === 0 ? { fday: "Saturday", bfast: "Weekend Off", lunch: "Weekend Off", htea: "Weekend Off", others: "Weekend Off" } : Saturday[0]
    //                 });
    //             });
    //     }
    // }, [userID]);

    const [todayMenu, setTodayMenu] = useState([]);
    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const d = new Date();
    const day = weekday[d.getDay()];

    useEffect(() => {
        if (menu[day]) {
            setTodayMenu(menu[day].others ? menu[day].others.split('/') : []);
        }
    }, [menu, day]);

    // useEffect(() => {
    //     localStorage.setItem('order', JSON.stringify(menuItems));
    //     const orderSummary = menuItems.map(items => items.name + '*' + items.quantity + '=' + items.amt).join(', ');
    //     const orderAmt = menuItems.reduce((sum, item) => sum + item.amt, 0);
    //     setAmount(orderAmt);
    //     setMessage(orderSummary.toString());
    // }, [menuItems]);

    return (
        <>
            {/* <h2>Other Snacks</h2> */}
            {/* <div>
                {todayMenu.map((item) => (
                    <p className={classes.bottomBorder} key={item}>
                        {item}
                        <span>
                            <button className={classes.btnQty} onClick={() => handleRemoveItem(item)}>-</button>
                            <button className={classes.btnQty} onClick={() => handleAddItem(item)}>+</button>
                        </span>
                        <br /><br /><br /><br />
                    </p>
                ))}
            </div> */}
            <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
            <input type="number" readOnly={order ? "readonly" : ""} placeholder={"₹"} onChange={(e) => setAmount(e.target.value)} value={parseInt(amount)} min={0} />
            <input type="text" readOnly={order ? "readonly" : ""} style={order ? { fontSize: "15px" } : {}} placeholder='Add Message' onChange={(e) => setMessage(e.target.value)} value={message} />
            <div className={classes.ButtonDiv}>
                <button disabled={isButtonDisabled} onClick={handlePay}>PAY</button>
                <button onClick={() => { dispatch(closePaymenu(false)) }}>CANCEL</button>
            </div>
         </>
    );
};

export default PayMenuOtherSnacks;
